import React, { Component } from "react";
import { Link } from "react-router-dom";

// Layout
import Header from "../layout/header/header1";

// Images
import bannerImg from "../../images/banner/banner3.jpg";
import news_1 from "../../images/news/news13_1.jpg";
import news_2 from "../../images/news/news13_2.jpg";
import news_3 from "../../images/news/news13_3.jpg";
import news_4 from "../../images/news/news13_4.jpg";
import news_5 from "../../images/news/news13_5.jpg";
import news_6 from "../../images/news/news13_6.jpg";
import news_7 from "../../images/news/news13_7.jpg";
import news_8 from "../../images/news/news13_8.jpg";
import news_9 from "../../images/news/news13_9.jpg";
import news_10 from "../../images/news/news13_10.jpg";
import news_11 from "../../images/news/news13_11.jpg";
import news_12 from "../../images/news/news13_12.jpg";
import news_13 from "../../images/news/news13_13.jpg";
import news_14 from "../../images/news/news13_14.jpg";
import news_15 from "../../images/news/news13_15.jpg";
import news_16 from "../../images/news/news13_16.jpg";
import news_17 from "../../images/news/news13_17.jpg";

import { withTranslation } from "react-i18next";


class news13 extends Component {
	componentDidMount() {

	}

	componentWillMount() {
		const { t } = this.props;
		document.getElementById('title').innerText = t("News13_Title");
	}

	componentWillUnmount() {
		const { t } = this.props;
		document.getElementById('title').innerText = t("Home_Title");
	}

	render() {
		const { t } = this.props;
		return (
			<>
				<Header />

				<div className="page-content">
					<div
						className="page-banner ovbl-dark"
						style={{ backgroundImage: "url(" + bannerImg + ")" }}
					>
						<div className="container">
							<div className="page-banner-entry">
								<h1 className="text-white">{t("News13_Title")}</h1>
							</div>
						</div>
					</div>
					<div className="breadcrumb-row">
						<div className="container">
							<ul className="list-inline">
								<li>
									<Link to="/">{t("News13_LinkHome")}</Link>
								</li>
								<li>{t("News13_LinkCourses")}</li>
							</ul>
						</div>
					</div>
					<div className="content-block">
						<div className="section-area section-sp1">
							<div className="container">
								<div className="row d-flex flex-row-reverse">
									<div className="col-xl-9 col-lg-8 col-md-12 col-sm-12">
										<div className="courses-post">
											<h1>{t("News13_Content_H")}</h1>
											<p><a href="https://mp.weixin.qq.com/s/xFjkTMkoN_AJ43r8dDcbvg" target="_blank" rel="noreferrer" style={{ textDecoration: 'underline' }}>({t("News13_Content_Reposted")})</a></p>
											<p>{t("News13_Content_P1")}</p>
											<p>{t("News13_Content_P2")}</p>
											<img src={news_1} alt="" />
											<hr />
											<img src={news_2} alt="" />
											<hr />
											<p>{t("News13_Content_P3")}</p>
											<img src={news_3} alt="" />
											<hr />
											<p>{t("News13_Content_P4")}</p>
											<img src={news_4} alt="" />
											<hr />
											<img src={news_5} alt="" />
											<hr />
											<img src={news_6} alt="" />
											<hr />
											<p>{t("News13_Content_P5")}</p>
											<img src={news_7} alt="" />
											<hr />
											<img src={news_8} alt="" />
											<hr />
											<p>{t("News13_Content_P6")}</p>
											<p>{t("News13_Content_P7")}</p>
											<img src={news_9} alt="" />
											<hr />
											<p>{t("News13_Content_P8")}</p>
											<div className="col-lg-6 col-md-12 col-sm-12">
											<iframe
												width="800"
												height="600"
												src="https://www.youtube.com/embed/h-2EYS4m66U"
												title="Mason"
												allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
												allowFullScreen
											></iframe><br /><br />
											</div>
											<p>{t("News13_Content_P9")}</p>
											<p>{t("News13_Content_P10")}</p>
											<img src={news_10} alt="" />
											<hr />
											<p>{t("News13_Content_P11")}</p>
											<iframe
												width="800"
												height="600"
												src="https://www.youtube.com/embed/EdpWmtI6Jew"
												title="Leo"
												allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
												allowFullScreen
											></iframe><br /><br />
											<p>{t("News13_Content_P12")}</p>
											<img src={news_11} alt="" />
											<hr />
											<p>{t("News13_Content_P13")}</p>
											<iframe
												width="800"
												height="600"
												src="https://www.youtube.com/embed/sdGNZ1GbyMY"
												title="Hanna"
												allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
												allowFullScreen
											></iframe><br /><br />
											<p>{t("News13_Content_P14")}</p>
											<img src={news_12} alt="" />
											<hr />
											<img src={news_13} alt="" />
											<hr />
											<p>{t("News13_Content_P15")}</p>
											<img src={news_14} alt="" />
											<hr />
											<p>{t("News13_Content_P16")}</p>
											<img src={news_15} alt="" />
											<hr />
											<img src={news_16} alt="" />
											<hr />
											<p>{t("News13_Content_P17")}</p>
											<img src={news_17} alt="" />
											<hr />
											

										</div>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default news13 = withTranslation()(news13);
